function shareFolderDialog () {
  return {
    restrict: 'E',
    templateUrl: '/arts/dialogs/share-folder/share-folder-dialog.html?$$REVISION$$'
  }
}

export { shareFolderDialog }
